import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from 'vue'
import MapCommon from '@/components/map-device'
import { lngReg, latReg } from '@/common/regexp'
import { CODE_ENUM } from '@/common/enum'
import { ElMessage } from 'element-plus'
import { cloneDeep, isEmpty } from 'lodash'
import { queryLocationRgeo, deviceLocationAdd } from '@/api'
import moment from 'moment'
import i18n from '@/i18n'
import { validateDMS, DMSToDecimal, decimalToDMS } from '@/utils/map.utils'

// DMS

export default /*#__PURE__*/_defineComponent({
  __name: 'add-point',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const latLngType = ref('DD')

const t = i18n.global.t




const mapRef = ref()
const formRef = ref()

const formData = ref({
  address: '',
  lng: '',
  lat: '',
  time: '',
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      //   if (!isEmpty(props.data)) {
      //     const mo = cloneDeep(props.data)
      //     formData.value = mo
      //   }
    } else {
      formRef.value.resetFields()
    }
  }
)

const previewDisabled = computed(() => {
  return !(lngReg.test(formData.value.lng) && latReg.test(formData.value.lat))
})

const validateMethod: any = (reg: RegExp, message: string) => {
  return (rule: any, value: any, callback: any) => {
    if (latLngType.value === 'DMS') {
      if (!validateDMS(value)) {
        callback(new Error(message))
      } else {
        const num: any = DMSToDecimal(value)
        if (reg.test(num)) {
          callback()
        } else {
          callback(new Error(message))
        }
      }
    }
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error(message))
    }
  }
}
const rules: any = {
  lng: [
    {
      required: true,
      message: '请输入',
    },
    {
      validator: validateMethod(lngReg, t('D_TRAIL.formatterErr')),
      trigger: 'blur',
    },
  ],
  lat: [
    {
      required: true,
      message: '请输入',
    },
    {
      validator: validateMethod(latReg, t('D_TRAIL.formatterErr')),
      trigger: 'blur',
    },
  ],
  time: { required: true, message: t('D_TRAIL.msgTime') },
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      toAddPoint()
      //   $emit('on-map-change', { ...formData.value })
      //   $emit('update:visible', false)
    }
  })
}

const toAddPoint = async () => {
  const { address = '', lng = '', lat = '', time = '' } = formData.value
  let longitude: any = lng
  let latitude: any = lat

  if (latLngType.value === 'DMS') {
    longitude = DMSToDecimal(lng)
    latitude = DMSToDecimal(lat)
  }
  const sendTime = moment(time).valueOf()
  const res: any = await deviceLocationAdd({
    addressName: address,
    deviceId: props.data.deviceId,
    latitude: latitude,
    longitude: longitude,
    sendTime,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    handleClose()
    $emit('success')
    ElMessage.success(t('D_TRAIL.msgSuccess'))
  }
}

const handleClose = () => {
  $emit('update:visible', false)
}

// 预览 并且 获取定位
const toPreviewLocation = () => {
  preview()
  const { lng, lat } = formData.value
  let longitude: any = lng
  let latitude: any = lat

  if (latLngType.value === 'DMS') {
    longitude = DMSToDecimal(lng)
    latitude = DMSToDecimal(lat)
  }
  queryLocation({
    longitude,
    latitude,
  })
}

const preview = () => {
  const { lng, lat } = formData.value
  if (!lng || !lat) {
    return
  }
  let longitude: any = lng
  let latitude: any = lat
  if (latLngType.value === 'DMS') {
    longitude = DMSToDecimal(lng)
    latitude = DMSToDecimal(lat)
  }
  mapRef.value.moveMarker({
    lat: latitude,
    lng: longitude,
  })
}

const onLocationChange = ({ lng, lat }: any) => {
  let longitude = lng
  let latitude = lat

  if (latLngType.value === 'DMS') {
    longitude = decimalToDMS(lng)
    latitude = decimalToDMS(lat)
  }
  formData.value = {
    ...formData.value,
    lng: longitude,
    lat: latitude,
  }
  queryLocation({
    longitude: lng,
    latitude: lat,
  })
  formRef.value?.resetFields?.('lng')
  formRef.value?.resetFields?.('lat')
}

// 逆地理编码
const queryLocation = async ({ longitude, latitude }: any) => {
  const res: any = await queryLocationRgeo({
    longitude,
    latitude,
  })

  if (res?.code === CODE_ENUM.SUCCESS) {
    formData.value.address = res?.data?.address || ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: _ctx.$t('D_TRAIL.addPoinetTitle'),
    width: "790px",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: handleClose }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('COMMON.btnCancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('COMMON.btnYes')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(MapCommon), {
        ref_key: "mapRef",
        ref: mapRef,
        class: "map-container",
        onOnload: preview,
        onOnLocationChange: onLocationChange
      }, null, 512),
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: rules,
        class: "ws_mt32 form",
        "label-width": 80
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('D_TRAIL.address'),
            prop: "address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.address,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.address) = $event)),
                clearable: "",
                maxlength: "50"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('D_TRAIL.popLng'),
                    prop: "lng"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.lng,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.lng) = $event)),
                        clearable: "",
                        maxlength: "16"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: latLngType.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((latLngType).value = $event)),
                            style: {"width":"85px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('D_CREATE.latLngType1'),
                                value: "DMS"
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('D_CREATE.latLngType2'),
                                value: "DD"
                              }, null, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('D_TRAIL.popLat'),
                    prop: "lat"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.lat,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.lat) = $event)),
                        clearable: "",
                        maxlength: "16"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: latLngType.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((latLngType).value = $event)),
                            style: {"width":"85px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('D_CREATE.latLngType1'),
                                value: "DMS"
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('D_CREATE.latLngType2'),
                                value: "DD"
                              }, null, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    disabled: _unref(previewDisabled),
                    onClick: toPreviewLocation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('D_TRAIL.preview')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('D_TRAIL.trailTime'),
                    prop: "time"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.time,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.time) = $event)),
                        type: "datetime",
                        placeholder: _ctx.$t('D_TRAIL.trailTimePla')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})